import { useEffect, useState } from "react";
import axios from "axios";
import { Truck, ArrowUpRight } from "lucide-react";
import { API, getAuthHeader } from "@/App";
import { openPage } from "@/components/BackBar";

// Dashboard card for the outsourcing team: today's FREESHIP parcels + still pending.
export const FreeshipTodayCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/order-register/freeship-today`, { headers: getAuthHeader() })
      .then(r => setD(r.data)).catch(() => setD(null));
  }, []);
  if (!d?.visible) return null;
  return (
    <button type="button" data-testid="freeship-today-card"
      onClick={() => openPage("/pending-worklist?bucket=FREESHIP&age=total")}
      className="group flex w-full items-center gap-4 rounded-xl border border-teal-200 bg-white/80 p-4 text-left shadow-lg transition-colors hover:border-teal-400 hover:bg-teal-50/60">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-teal-100"><Truck className="h-6 w-6 text-teal-700" /></div>
      <div className="flex-1">
        <p className="text-sm font-semibold text-slate-800">Freeship (outsourced) today</p>
        <p className="text-xs text-slate-600">
          <b className="text-lg text-slate-900" data-testid="freeship-today-count">{d.today}</b> new today ·{" "}
          <b className="text-teal-700" data-testid="freeship-pending-count">{d.pending}</b> still pending ·{" "}
          <b className="text-red-600" data-testid="freeship-over48-count">{d.over_48h}</b> over 48h
        </p>
      </div>
      <ArrowUpRight className="h-5 w-5 text-teal-600 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </button>
  );
};
